if (!customElements.get("m-iti-icons")) {
  class MItiIcons extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.onChange = this.onChange.bind(this);
    }

    connectedCallback() {
      this.sliderContainer = this.querySelector(".swiper-container");
      if (!this.sliderContainer) return;

      this.total = parseInt(this.dataset.total, 10) || 0;
      this.perView = parseFloat(this.dataset.perViewMobile) || 1.2;
      this.enabled = this.dataset.mobileSlider === "true";

      if (!this.enabled || this.total < 2) return;

      // The slider is a mobile-only affordance; on larger screens the icons
      // are a plain grid, so tear Swiper down rather than hide it.
      this.mql = window.matchMedia("(max-width: 767px)");
      this.onChange();

      if (typeof this.mql.addEventListener === "function") {
        this.mql.addEventListener("change", this.onChange);
      } else {
        this.mql.addListener(this.onChange);
      }
    }

    disconnectedCallback() {
      if (this.mql) {
        if (typeof this.mql.removeEventListener === "function") {
          this.mql.removeEventListener("change", this.onChange);
        } else {
          this.mql.removeListener(this.onChange);
        }
      }
      this.destroySlider();
    }

    onChange() {
      if (this.mql.matches) {
        this.initSlider();
      } else {
        this.destroySlider();
      }
    }

    initSlider() {
      if (this.slider) return;

      this.classList.add("is-slider");
      this.slider = new DeliLibs.Swiper(this.sliderContainer, {
        slidesPerView: this.perView,
        spaceBetween: 16,
        loop: false,
        watchOverflow: true,
        pagination: {
          el: this.querySelector(".swiper-pagination"),
          clickable: true,
          bulletClass: "m-dot",
          bulletActiveClass: "m-dot--active",
        },
      });
    }

    destroySlider() {
      if (this.slider) {
        this.slider.destroy(true, true);
        this.slider = null;
      }
      this.classList.remove("is-slider");
    }
  }

  customElements.define("m-iti-icons", MItiIcons);
}
